import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const AGENDA = 'agenda'
const START_DATETIME = 'start_datetime'
const DURATION_MINUTES = 'duration_minutes'
const LOCATION = 'location'
const NOTES = 'notes'
const PARTICIPANTS = 'participants'

/**
 * Form model
 */
const formModel = () => {
  return {

    [LOCATION]: {
      label: `${t('meetings.location')}`,
      name: LOCATION,
      required: true,
    },
    [NOTES]: {
      label: `${t('meetings.notes')}`,
      name: NOTES,
      required: true,
    },
    [AGENDA]: {
      label: `${t('meetings.agenda')}`,
      name: AGENDA,
      required: true,
    },
    [START_DATETIME]: {
      label: `${t('common.start-time')}`,
      name: START_DATETIME,
      required: true,
    },
    [DURATION_MINUTES]: {
      label: `${t('common.duration-minutes')}`,
      name: DURATION_MINUTES,
      required: true,
    },
    [PARTICIPANTS]: {
      label: `${t('meetings.participant')}`,
      name: PARTICIPANTS,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {

  [LOCATION]: '',
  [NOTES]: '',
  [AGENDA]: '',
  [START_DATETIME]: '',
  [DURATION_MINUTES]: '',
  [PARTICIPANTS]: [
    {
      participant: {
        id: '',
        title: '',
      },
      email: '',
      role: '',
      phone: '',
      has_attended: false
    },
  ],
}

/**
 * Form data validation
 */
export const validationSchema = (userRole: string) =>
  yup.object().shape({

    [LOCATION]: yup.string().required(`${t('errors.required-error-message')}`),
    [NOTES]: yup.string().required(`${t('errors.required-error-message')}`),
    [AGENDA]: yup.string().required(`${t('errors.required-error-message')}`),
    [START_DATETIME]: yup
      .date()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
    [DURATION_MINUTES]: yup.number().required(`${t('errors.required-error-message')}`),
    [PARTICIPANTS]: yup
      .array()
      .nullable()
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
